import React from 'react'
import WhatsappIcon from '../../assets/contact-us/Whatsapp.inline.svg'
import './whatsapp-float.scss'

const WHATSAPP_URL = 'https://wa.me/message/Q22RABZCIQ45L1'

const WhatsappFloat = () => {
  return (
    <a
      className="ss-whatsapp-float"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
    >
      <WhatsappIcon />
    </a>
  )
}

export default WhatsappFloat
